<template>
  <div class="timetable-container" v-if="weeklyTimingsData">
    <table class="md-whiteframe-z2 timetable">
      <thead>
        <tr>
          <th class="timetable-title"></th>
          <th
            v-for="(hourItem, index) in weeklyTimingsData.hours"
            :key="hourItem + index"
          >
            {{ hourItem }}
          </th>
        </tr>
      </thead>
      <tbody class="tbody">
        <tr
          v-for="(dayItem, dayIndex) in weeklyTimingsData.days"
          :key="dayItem.nameOfDay + dayIndex"
        >
          <td class="timecell timetable-title">
            {{ dayItem.nameOfDay | translate }}
          </td>
          <td
            v-bind:class="[
              item.value === 1
                ? 'pink-cell'
                : item.value === 0
                ? 'green-cell'
                : 'blue-cell',
              'timecell'
            ]"
            v-for="(item, hourIndex) in dayItem.hours"
            :key="item.nameOfHour + hourIndex"
            @click="$emit('swapItems', dayIndex, hourIndex)"
          >
            {{
              item.value === 1 ? "Off" : item.value === 0 ? "On" : item.value
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="wrap-btn-timer my-4">
      <v-btn @click="$emit('selectAllTimeTableData')">{{
        "lng_select_all" | translate
      }}</v-btn>
      <v-btn @click="$emit('clearAllTimeTableData')">{{
        "lng_clear_all" | translate
      }}</v-btn>
      <!-- <v-btn @click="$emit('copyMondayTimeTableData')">{{
        "lng_copy_monday" | translate
      }}</v-btn> -->
      <v-btn
        color="rgb(84,110,122)"
        class="white--text"
        @click="$emit('saveTimeTableData')"
        >{{ "lng_save" | translate }}</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "TimeTablePerHour",
  data() {
    return {
      weeklyTimingsData: undefined
    };
  },
  props: {
    timingsData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    timingsData: function(newVal) {
      this.weeklyTimingsData = newVal;
    }
  },
  mounted() {
    this.weeklyTimingsData = this.timingsData;
  }
};
</script>
<style scoped>
.wrap-btn-timer {
  justify-content: flex-start;
  display: flex;
  padding-left: 12px;
}
</style>
